















import Vue from 'vue';
import LeftSidebar from './components/LeftSidebar.vue';
import { JobProgress } from '@/types';
import { getProgressPhases } from '@/api';
import { getRememberMe } from '@/util';
import { mapGetters } from 'vuex';
import { ActionType } from '@/constants';

export default Vue.extend({
  name: 'Home',
  components: {
    LeftSidebar,
    PricingBreakdownModal: () => import('./components/PricingBreakdownModal.vue')
  },
  computed: {
    ...mapGetters([
      'signedIn',
      'jobDetails'
    ])
  },
  data () {
    return {
      phaseProgressData: {} as JobProgress,
      selectedHomes: '' as string | null,
      isVisiblePrincingBreakdownModal: false
    };
  },
  async beforeMount () {
    this.selectedHomes = getRememberMe();
    await this.fetchUserProgress();
  },
  methods: {
    async fetchUserProgress () {
      if (this.selectedHomes) {
        await getProgressPhases(this.selectedHomes).then(data => {
          if (data) {
            this.phaseProgressData = data;
            this.$store.dispatch(ActionType.SET_JOB_OWNERSHIP_STATUS, data.status);
            this.$store.dispatch(ActionType.SET_MILESTONE_DATA, this.phaseProgressData.mileStones);
          }
        });
      }
    }
  }
});
